export const certificatePaths = {
  base: 'certiciate',
  workCertificate: 'work-certificate',
};

export const certiciatetRoutes = {
  WorkCertificate: `/${certificatePaths.base}/${certificatePaths.workCertificate}`,
};
